import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addInventoryPopOverTitle: {
    description: 'Add inventory pop-over title',
    defaultMessage: 'Add Inventory',
    id: 'n+8erh',
  },
  inventoryPopoverCancel: {
    description: 'Add inventory pop-over cancel button',
    defaultMessage: 'Cancel',
    id: 'jhSUR6',
  },
  inventoryPopoverAdd: {
    description: 'Add inventory pop-over add button',
    defaultMessage: 'Add',
    id: '9D0qM0',
  },
  addInventoryErrorTitle: {
    description: 'Add inventory error notification title',
    defaultMessage: 'Add Inventory Error',
    id: 'HLzLT3',
  },
  addInventoryErrorMessage: {
    description: 'Add inventory error notification message',
    defaultMessage: 'Error adding inventory',
    id: 'cgHXKu',
  },
});
